import { mapFieldToCategory } from '../../../services/mapFieldToCategory';
import { SideNavCategory } from '../../../components/side-nav';
import { ReportField } from '../../../models/reportField';

const getAndMapReportFieldToSideNavCategories = (
  reportFields: ReportField[],
): SideNavCategory<ReportField>[] => {
  const standardFields = mapFieldToCategory(reportFields) as SideNavCategory<
    ReportField
  >[];

  return standardFields;
};

export default getAndMapReportFieldToSideNavCategories;
